import React, { useState } from "react";
import { Constant } from "../../../../../helper/constant";
import { formatDateTransaction } from "../../../../../helper/formatDate";
import { useNavigate } from "react-router-dom";
import { getInitialDate } from "../../../../../helper/formatDate";
import "./clinicPartnerHeader.css";

const ClinicPartnerHeader = ({ typeOfSales, onClickSearch }) => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [dateInput, setDateInput] = useState("");
  const [partnerData, setPartnerData] = useState({
    partner_id: "",
    partner_name: "",
  });
  const [suggestionPartner, setSuggestionPartner] = useState([]);
  const [startDate, setStartDate] = useState(getInitialDate("daily"));
  const [endDate, setEndDate] = useState(getInitialDate("daily"));

  // =====================
  // Method Definition
  // =====================

  const getDateFilter = () => {
    switch (typeOfSales) {
      case "daily":
        return "date";
      case "monthly":
        return "month";
      case "yearly":
        return "number";
      case "ranged":
        return "ranged";
    }
  };

  const onFilterClicked = () => {
    const queryJson = {
      date: formatDateTransaction(dateInput, typeOfSales),
      start_date: formatDateTransaction(startDate, "daily"),
      end_date: formatDateTransaction(endDate, "daily"),
      partner_id: partnerData.partner_id,
    };
    onClickSearch(queryJson, partnerData.partner_name);
  };

  const checkPartnerData = (keyword) => {
    if (keyword.length > 1) {
      checkPartnerAutoComplete(keyword);
    } else {
      setSuggestionPartner([]);
    }
  };

  const selectPartner = (partner) => {
    setPartnerData({
      partner_id: partner.partner_id,
      partner_name: partner.partner_name,
    });
    setSuggestionPartner([]);
  };

  // =====================
  // Request Method
  // =====================

  const checkPartnerAutoComplete = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/partner/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionPartner(data.partners);
    } catch (error) {
      setSuggestionPartner([]);
    }
  };

  return (
    <div className="input-filter-transaction-partner">
      <h4>Filter Dengan: </h4>
      <div className="filter-input-field-partner-container">
        {typeOfSales === "daily" || typeOfSales === "monthly" ? (
          // DAILY & MONTHLY
          <input
            className="filter-input-date-partner"
            type={getDateFilter()}
            value={dateInput}
            onChange={(e) => setDateInput(e.target.value)}
          />
        ) : typeOfSales === "yearly" ? (
          // YEARLY
          <input
            className="filter-input-date-partner"
            type="number"
            min="1900"
            max="2100"
            value={dateInput}
            onChange={(e) => setDateInput(e.target.value)}
            placeholder="Select year"
          />
        ) : typeOfSales === "ranged" ? (
          // RANGED
          <div style={{ display: "flex", gap: "12px" }}>
            <input
              className="medical-treatment-record-input-date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <input
              className="medical-treatment-record-input-date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        ) : null}

        <div>
          <input
            className="input-field-partner-transaction-container"
            type="text"
            value={partnerData.partner_name ? partnerData.partner_name : ""}
            onChange={(e) => {
              setPartnerData({
                partner_id: "",
                partner_name: e.target.value,
              });
              checkPartnerData(e.target.value);
            }}
            onBlur={() => setTimeout(() => setSuggestionPartner([]), 200)}
            placeholder="Nama partner"
          />
          {suggestionPartner.length > 0 && (
            <ul className="dropdown-list">
              {suggestionPartner.map((partner) => (
                <li key={partner.partner_id}>
                  <button
                    className="dropdown-button"
                    onClick={() => {
                      selectPartner(partner);
                    }}
                  >
                    {partner.partner_name}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <button
        className="confirm-sales-filter"
        type="button"
        onClick={onFilterClicked}
      >
        Cari penjualan
      </button>
    </div>
  );
};

export default ClinicPartnerHeader;
